<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2" class="pa-0 hidden-xs-only">
          <SideMenu/>
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="10" class="nav-right pa-0 pl-sm-14">
          <OfferForm :offerObs="offer" :titleForm="getTitle" />
        </v-col>
      </v-row>
    </v-container>
    
    <Footer />
  </div>
</template>
<script>
import SideMenu from "@/components/SideMenu";
import OfferForm from "@/components/OfferForm";
import { meta } from "@/libs/mixins";

export default {
    name: "OfferEdit",

    props: {
        offer: {
            type: Object,
            required: true,
        },
    },

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Editando publicación",
        });
    }, 

    components: {
        SideMenu,
        OfferForm,
    },

    computed: {
        getTitle() {
            return `Editando publicación "${this.offer.title}"`;
        }
    },
};
</script>
